import React, { useEffect } from 'react'
import CardNav from '../Common/components/CardNav'
import { track } from 'statsig'
import { STATSIG, PAGE } from 'statsig/events'
import './GrowthHub.css'

const HUB_ITEMS = [
    {
        key: 'landingpage',
        title: 'Personal site & Bluerate',
        image: 'CardBackground-PersonalSite.png', // 'CardBackground-PersonalSite.png',
        description:'Build credibility and generate leads with your own microsite.',
        link: '/app/landingpage',
    },
    {
        key: 'openhousefinder',
        title: 'Open house finder',
        image: 'CardBackground-OpenHouse.png', // 'CardBackground-OpenHouse.png',
        description:
             'Easily find open houses near you and connect with real estate professionals.',
        link: '/app/openhousefinder',
    },
    // {
    //     key: 'bluerate',
    //     title: 'Bluerate',
    //     image: 'CardBackground-MyMortgageRates.png', // 'My-Mortgage-Rates.png', 
    //     description:
    //         'This is the Marketplace Management page—use it to enroll, activate, or deactivate your launch.',
    //     link: '/app/bluerate',
    // },
]

const GrowthHub = () => {
    useEffect(() => {
        track(STATSIG.COMMON.VIEW, PAGE.GROWTH_HUB, { page: PAGE.GROWTH_HUB })
    }, [])

    return (
        <div className="growthhub-container">
            <div className="growthhub-header">
                <div className="growthhub-title">Growth hub</div>
                <div className="growthhub-subtitle mb-4">
                    Accelerate your business growth with Zeitro.
                </div>
            </div>
            <CardNav items={HUB_ITEMS} statsigSource="growth_hub" />
        </div>
    )
}

export default GrowthHub
